<mat-card class="reserva-bucket" 
          [style.top.px]="top"  
          [style.height.px]="height"
          [ngClass]="[getColor(reserva.reservation_type)]"
          (click)="openReserva()"
          matTooltip="{{reserva.description}} - {{reserva.field_capacity == 18 ? '9vs9' : '7vs7'}}">

  <div class="hour d-flex justify-content-between">
    <span>
      {{ desde | date:"HH:mm" }} - {{ hasta | date:"HH:mm" }}
    </span>
    <span > 
      <b *ngIf="reserva.payment_variable && !reserva.deposit_paid">Señado</b>
      <b *ngIf="reserva.deposit_paid" style="color: #167200">Señado</b>
    </span>
  </div>
  <span *ngIf="reserva.planner; else f_user">{{ reserva.planner }}</span>
  <ng-template #f_user>{{ reserva.name }}</ng-template>
  <div class="bottom-line"></div>

</mat-card>
